import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  Address: string = environment.address;
  ContactNo: string = environment.mobileNo;
  ContactEmail: string = environment.emailId;
  companysname: string = environment.companyShortName;
  companyfname: string = environment.companyFullName;
  facebook: string = environment.facebookLink;
  instagram: string = environment.instagramLink;
  twitter: string = environment.twitterLink;
  linkedin: string = environment.linkedinLink;
  About = environment.about;
  currentYear: number = new Date().getFullYear();
  constructor() { }

  ngOnInit() {
  }

}
